<template>
  <div
    :class="`milestone ${type}-milestone t-shadow`"
    :style="`
    ${`height: ${getZoom() * 25}px; width: ${getZoom() * 25}px; border-radius: ${getZoom() * 3}px;`}

    `"
    >
    <div
      id="milestone-token"
      class="milestone-token font-weight-light"
      :style="`font-size: ${getZoom() * 12}px;`"
      >
      <slot>
        {{milestone.token}}
      </slot>
    </div>
    <div
      v-if="milestone.status != 'none' && milestone.status != undefined"
      class="milestone-badge"
      :style="`width: ${getZoom() * 12}px; height: ${getZoom() * 12}px; top: 0%; border-radius: ${getZoom() * 10}px; border: solid 1px #212121;`"
      >
      <v-icon
        id="milestone-badge-icon"
        class="milestone-badge-icon"
        :color="milestone.status === 'stop' ? 'red' : 'black'"
        :style="`font-size: ${getZoom() * 10}px !important;`"
        >
        <!-- done -->
        {{getStatusIcon()}}
      </v-icon>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    props: ['milestone', 'zoom', 'type'],
    computed: {
      ...mapGetters('View', [
        'getTaktplanZoom'
      ]),
    },
    methods: {
      getZoom() {
        if (this.zoom) {
          return this.zoom;
        } else {
          return 1;
        }
      },
      getStatusIcon() {
        if (this.milestone_status_array.find(status => status.name === this.milestone.status)) {
          return this.milestone_status_array.find(status => status.name === this.milestone.status).icon;
        } else {
          return '';
        }
      }
    },
    data() {
      return {
        milestone_status_array: [
          {name: 'none', icon: ''},
          {name: 'done', icon: 'done'},
          {name: 'stop', icon: 'warning'}
        ]
      }
    }
  }
</script>
<style scoped>
  .project-milestone {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
  .train-milestone {
    background-color: #121212;
    color: white;
    border: 1px solid white;
  }
  .milestone {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) / 8);
    height: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) / 8);
    border-radius: 1px;
    transform: rotate(45deg);
  }
 
  .milestone-token {
    transform: rotate(-45deg);
    font-size: 0px;
    user-select: none;
    transition: all 0.1s ease-in-out
  }
  
  .milestone-badge {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-45deg);
    left: 50%;
    top: 50%;
    width: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8);
    height: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8);
    border-radius: 100%;
    background-color: white;
    z-index: 2;
    transform: translate(-50%, -50%);
    transition: all 0.1s ease-in-out

  }

  .milestone-badge-icon {
    transform: rotate(-45deg);
    font-size: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8) !important;
  }


  .milestone-icon {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    transform: rotate(45deg);
    cursor: pointer;
    background-color: white;
    background-color: var(--v-primary-base);
  }
</style>
